import React from 'react';

const ContentPlatform: React.FC = () => {
  return (
    <section id='content-platform' className='mb-20'>
      <div className='max-w-7xl mx-auto px-6 lg:px-8'>
        <div className='flex flex-col items-center justify-between mt-10 space-x-4 md:flex-row md:mx-10'>
          {/* Features Container */}
          <div className='flex flex-col items-start justify-between md:ml-14'>
            {/* Header */}
            <div className='flex flex-col mx-auto mb-20'>
              <div className='flex flex-row'>
                <p className='text-center md:text-left font-semibold uppercase mb-4'>
                  Content Management Platform
                </p>
              </div>
              <div className='text-3xl font-bold text-[#1d191f] md:w-3/5'>
                Engage visitors in a fun and gamified way, inspire them to
                support your mission
              </div>
            </div>

            {/* Platform Feature */}
            <div className='text-left self-start w-full md:w-1/2'>
              <strong className='text-2xl bg-clip-text text-[#357BFB]'>
                Premier templates designed for customer engagement on mobile web
              </strong>
            </div>
            <div className='text-left self-start w-full md:w-[90%] pt-3 mb-16'>
              <p className='text-md'>
                Expertly designed templates to match your brand and reach your visitors.
                No internal training, no visitor app downloads needed
              </p>
            </div>

            {/* Platform Feature */}
            <div className='text-left self-start w-full md:w-1/2'>
              <strong className='text-2xl bg-clip-text text-[#357BFB]'>
                Update and schedule content changes without replacing the physical QR code
              </strong>
            </div>
            <div className='text-left self-start w-full md:w-[90%] pt-3 mb-16'>
              <p className='text-md'>
                Replace, modify, and test content using the same QR code
              </p>
            </div>

            {/* Platform Feature */}
            <div className='text-left self-start w-full md:w-1/2 md:text-left'>
              <strong className='text-2xl bg-clip-text text-[#357BFB]'>
                Implement friction-less donations with our free Stripe integration
              </strong>
            </div>
            <div className='text-left self-start w-full md:w-[90%] pt-3 mb-16'>
              <p className='text-md'>
                Ask visitors to support your cause by donating or learning more 
              </p>
            </div>

            {/* Platform Feature */}
            <div className='text-left self-start w-full md:w-1/2'>
              <strong className='text-2xl bg-clip-text text-[#357BFB]'>
                Expand multilingual access and inclusivity
              </strong>
            </div>
            <div className='text-left self-start w-full md:w-[90%] pt-3 mb-16'>
              <p className='text-md'>
                Sophisticated AI-based translation for 96 languages, plus audio templates
              </p>
            </div>

            {/* Platform Feature */}
            <div className='text-left self-start w-full md:w-1/2'>
              <strong className='text-2xl bg-clip-text text-[#357BFB]'>
                Custom build experiences with our in-house gamification team
              </strong>
            </div>
            <div className='text-left self-start w-full md:w-[90%] pt-3 mb-16'>
              <p className='text-md'>
                Interactive & engaging scavenger hunts, trivia, and experiences to keep your
                content, membership, and special events fresh and memorable
              </p>
            </div>

            {/* Platform Feature */}
            <div className='text-left self-start w-full md:w-1/2'>
              <strong className='text-2xl bg-clip-text text-[#357BFB]'>
                Easily publish content for seasonality, special groups, events and marketing materials
              </strong>
            </div>
            <div className='text-left self-start w-full md:w-[90%] pt-3 mb-16'>
              <p className='text-md'>
                Customize your content for various audiences using color-coded QR's and/or
                update content for in-venue signage and member outreach without re-printing
              </p>
            </div>
          </div>

          {/* Images Container */}
          <div className='flex flex-col max-w-xs items-center md:items-baseline'>
            <div className='relative'>
              <img className='' alt='' src={'/dino_example_mobile_screen.png'} />
            </div>

            <div className='relative z-10 bottom-24 right-0 md:right-[5rem] bg-white w-[14rem] shadow-md rounded-lg'>
              <img className='' alt='' src={'/dino_qr_code.png'} />
            </div>
          </div>
        </div>

        {/* Request a Demo */}
        <div className='flex flex-row items-center justify-center'>
          {/* Request Demo Button */}
          <a
            href='https://share.hsforms.com/1vQT5Dh5IQg6q5d23tBcocwr7uug'
            rel='noopener'
            target='_blank'
            className='flex flex-row rounded-full bg-[#89F5A0] text-[#333215] font-bold py-5 px-12 items-center my-6 text-xl md:self-start duration-150 hover:bg-[#333215] hover:text-[#89F5A0] hover:font-semibold hover:shadow-lg'
          >
            <span className='leading-6'>Request a Demo</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContentPlatform;
